import React, { useState } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Form } from 'react-bootstrap';
import axios from "axios";
import config from "../config";
import { useAuth } from "../context/AuthContext";

const AddCategoryDialog = ({ onCategoryAdded, onHide }) => {
    const { accessToken } = useAuth();

    // Initial state for category data
    const initialCategoryData = {
        category_name: "",
        description: "",
        type: "Wedding", // Default value
    };

    const [categoryData, setCategoryData] = useState(initialCategoryData);
    const [loading, setLoading] = useState(false);

    // Predefined category types
    const categoryTypes = [
        { label: "Wedding", value: "Wedding" },
        { label: "Development", value: "Development" },
        { label: "Marketing", value: "Marketing" }
    ];

    const handleChange = (e) => {
        setCategoryData({ ...categoryData, [e.target.name]: e.target.value });
    };

    const handleTypeChange = (e) => {
        setCategoryData({ ...categoryData, type: e.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await axios.post(
                `${config.apiBASEURL}/ClientFormRoutes/add-form-category`,
                categoryData,
                { headers: { Authorization: `Bearer ${accessToken}` } }
            );
            onCategoryAdded(); // Notify parent about the new category
            handleCancel(); // Reset form after successful submission
        } catch (error) {
            console.error('Error adding category:', error);
        } finally {
            setLoading(false);
        }
    };

    const handleCancel = () => {
        setCategoryData(initialCategoryData); // Reset to initial state
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
                <Form.Label>Category Name</Form.Label>
                <Form.Control
                    type="text"
                    name="category_name"
                    value={categoryData.category_name}
                    onChange={handleChange}
                    required
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Type</Form.Label>
                <Dropdown
                    value={categoryData.type}
                    options={categoryTypes}
                    onChange={handleTypeChange}
                    placeholder="Select a Type"
                    optionLabel="label"
                    className="w-100"
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Description</Form.Label>
                <Form.Control
                    type="text"
                    name="description"
                    value={categoryData.description}
                    onChange={handleChange}
                />
            </Form.Group>

            <div className="d-flex justify-content-end gap-2">
                <Button
                    type="button"
                    label="Reset"
                    severity="secondary"
                    icon="pi pi-times"
                    outlined
                    className='border-0 py-2'
                    onClick={handleCancel}
                    disabled={loading}
                />
                <Button
                    type="submit"
                    label="Add"
                    severity="success"
                    icon="pi pi-check"
                    outlined
                    className='border-0 py-2'
                    loading={loading}
                    disabled={!categoryData.category_name || !categoryData.type || !categoryData.description}
                />
            </div>
        </Form>
    );
};

export default AddCategoryDialog;
